import { getContent } from '../utils/formatValue';

const calculateRelevance = (
    item,
    searchValue,
    primaryLabel,
    secondaryLabel
) => {
    let score = 0;

    const calculateMatchScore = (label) => {
        const labelValue = item[label]?.toLowerCase();
        if (labelValue?.includes(searchValue)) {
            return searchValue.length / labelValue.length;
        }
        return 0;
    };

    score += calculateMatchScore(primaryLabel);

    if (secondaryLabel) {
        score += calculateMatchScore(secondaryLabel);
    }

    return score;
};

export const filterItemsBySearchTerm = (
    item,
    searchLowerCase,
    primaryLabel,
    secondaryLabel
) => {
    const primaryValue = getContent(item, primaryLabel);
    const secondaryValue = secondaryLabel
        ? getContent(item, secondaryLabel)
        : '';
    const matchesPrimary = primaryValue
        ?.toLowerCase()
        ?.includes(searchLowerCase);
    const matchesSecondary = secondaryValue
        ?.toLowerCase()
        ?.includes(searchLowerCase);

    return matchesPrimary || matchesSecondary;
};

const isItemSelected = (item, selected) => {
    // selected can be an array or a single object
    if (Array.isArray(selected)) {
        return selected.some((i) => i.id === item.id);
    }
    return selected?.id === item.id;
};

const sortBySelected = (a, b, selected) => {
    const isSelectedA = isItemSelected(a, selected);
    const isSelectedB = isItemSelected(b, selected);

    if (isSelectedA && !isSelectedB) {
        return -1;
    }
    if (!isSelectedA && isSelectedB) {
        return 1;
    }

    return 0;
};

export const sortItems = (
    a,
    b,
    searchLowerCase,
    selected,
    items,
    primaryLabel,
    secondaryLabel
) => {
    if (items && items.length > 4) {
        return sortBySelected(a, b, selected);
    }

    return (
        calculateRelevance(b, searchLowerCase, primaryLabel, secondaryLabel) -
        calculateRelevance(a, searchLowerCase, primaryLabel, secondaryLabel)
    );
};
export const getSelectedValue = (multiple, value, items) => {
    if (multiple) {
        return Array.isArray(value)
            ? items.filter((item) => value.includes(item.id))
            : [];
    }
    return value ? items.find((item) => item.id === value) || null : null;
};

export const mergeItems = (prevItems, newItems) => {
    const seenIds = new Set();
    return [...prevItems, ...newItems].filter((item) => {
        if (item.id === null || seenIds.has(item.id)) {
            return false;
        }
        seenIds.add(item.id);
        return true;
    });
};


export const handleFetchResponse = (res, replaceId = null) => {
    let result = res.data || [];
    if (replaceId) {
        result = result.map((item) => getReplacedId(item, replaceId));
    }
    return result;
};

const getReplacedId = (item, replaceValue) => {
    if (!item[replaceValue]) return item;
    return {
        ...item,
        id: item[replaceValue]
    };
};

